import type en from "../en/call";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  callUs: "اتصل بنا",
  callAi: "اتصل بالذكاء الاصطناعي",
  heroPrompt: "لا تعرف من أين تبدأ؟ تحدّث مع مساعد Storelancer الذكي",
  openCall: "اتصل بمساعد Storelancer الذكي",
  modalTitle: "خبير Storelancer الذكي",
  chooseLanguage: "اختر لغة المكالمة",
  more: "المزيد",
  moreLanguages: "لغات أخرى",
  selectLanguage: "اختر لغة",
  whoToTalk: "مع من تودّ التحدث؟",
  style_kind: "لطيف وصبور",
  style_fast: "سريع وعملي",
  style_store: "المتجر والأعمال",
  style_apps: "التطبيقات والمنتجات",
  online: "متصل",
  talkTo: "اتصل بـ {name} ({style})",
  honestNote: "مساعدون صوتيون بالذكاء الاصطناعي — ليسوا أشخاصًا حقيقيين.",
  costNote: "قد تستهلك المكالمات أرصدة لكل دقيقة: {n} ⚡/دقيقة",
  freeNote: "المكالمات مجانية",
  balance: "رصيدك: {n} ⚡",
  close: "إغلاق",
  aiAssistant: "مساعد ذكي",
  callDuration: "مدة المكالمة",
  connecting: "جارٍ الاتصال…",
  listening: "يستمع…",
  thinking: "يفكّر…",
  speaking: "يتحدث…",
  ready: "جاهز — اكتب رسالة",
  micMuted: "الميكروفون مكتوم",
  waitingConfirm: "بانتظار تأكيدك",
  ended: "انتهت المكالمة",
  endedSummary: "انتهت المكالمة · {minutes} د · {credits} ⚡",
  mute: "كتم الميكروفون",
  unmute: "إلغاء كتم الميكروفون",
  hangUp: "إنهاء المكالمة",
  typeInstead: "اكتب بدلًا من ذلك",
  typePlaceholder: "اكتب رسالتك…",
  send: "إرسال",
  captions: "ترجمة مباشرة",
  you: "أنت",
  steps: "إجراءات المساعد",
  confirmTitle: "تأكيد هذا الإجراء",
  confirm: "تأكيد",
  cancel: "إلغاء",
  greeting: "مرحبًا، أنا {name}، مساعدك الذكي من Storelancer. كيف يمكنني مساعدتك اليوم؟",
  sayConfirm: "يرجى التأكيد على الشاشة.",
  sayNoCredits: "نفد رصيدك، لذلك انتهت المكالمة. يمكنك إضافة أرصدة والاتصال مجددًا.",
  sayMaxDuration: "وصلنا إلى الحد الأقصى لمدة المكالمة، لذلك انتهت.",
  reasonNoCredits: "انتهت المكالمة لأن رصيدك نفد.",
  reasonMaxDuration: "وصلت المكالمة إلى الحد الأقصى لمدتها.",
  reasonOther: "أنهى الخادم المكالمة.",
  addCredits: "إضافة أرصدة",
  openStore: "افتح متجرك",
  callAgain: "اتصل مجددًا",
  errUnsupported: "متصفحك لا يدعم التعرّف على الكلام. يمكنك كتابة رسائلك.",
  errPermission: "تم رفض الوصول إلى الميكروفون. اسمح به من إعدادات المتصفح أو اكتب بدلًا من ذلك.",
  errNoMic: "لم يتم العثور على ميكروفون. يمكنك الكتابة بدلًا من ذلك.",
  errNetwork: "تعذّر الوصول إلى خدمة الكلام. يمكنك الكتابة بدلًا من ذلك.",
  errFailed: "توقف التعرّف على الكلام. يمكنك الكتابة بدلًا من ذلك.",
  errNoSpeechOut: "لا يستطيع متصفحك قراءة الردود بصوت عالٍ — اقرأها في الترجمة.",
  errStart: "تعذّر بدء المكالمة.",
  errAiUnavailable: "المساعد الذكي غير مُعدّ على هذا الخادم.",
  errNoCreditsStart: "ليس لديك أرصدة كافية لبدء مكالمة.",
  errTurn: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  avatarsTitle: "صور شخصيات المكالمات",
  avatarsHelp: "ينشئ صورة واقعية بالذكاء الاصطناعي لكل شخصية مكالمة باستخدام نموذج الصور ويحفظها. الشخصيات خيالية وليست أشخاصًا حقيقيين.",
  generateMissing: "إنشاء الصور الناقصة",
  regenerateAll: "إعادة إنشاء الكل",
  generating: "جارٍ إنشاء الصور… قد يستغرق ذلك بضع دقائق.",
  generatedResult: "تم إنشاء {created}، و{skipped} موجودة مسبقًا، وفشل {failed}.",
  imagesNotConfigured: "توليد الصور غير مُعدّ على هذا الخادم (REPLICATE_API_TOKEN غير مضبوط).",
  noFemaleVoice: "لم يتم بعد اختيار صوت نسائي لهذه اللغة، لذلك تظهر ردود {name} كنص مكتوب. يمكن للمسؤول اختياره من الإدارة ← الذكاء الاصطناعي والأرصدة ← مختبر الأصوات.",
  voiceProviderError: "تعذّر تشغيل خدمة الصوت ({error})، لذلك تظهر الردود كنص مكتوب.",
  noMaleVoice: "لم يتم بعد اختيار صوت رجالي لهذه اللغة، لذلك تظهر ردود {name} كنص مكتوب. يمكن للمسؤول اختياره من الإدارة ← الذكاء الاصطناعي والأرصدة ← مختبر الأصوات.",
  chooseDialect: "أي لهجة؟",
  dialectHint: "سيستمع {name} ويرد بهذه اللهجة.",
};

export default ar;
